import React, {Component} 	from 'react';
import LangContext 			from '../LangContext';

/**
 * Add translate properties to WrappedComponent for getting translate
 * @param WrappedComponent
 * @returns {*}
 */
function localize(WrappedComponent) {
	return class extends Component {
		constructor(props) {
			super(props);
		}

		render() {
			return (
			    <LangContext.Consumer>
					{value =>
						<WrappedComponent {...this.props} {...value}/>
					}
				</LangContext.Consumer>
			);
		}
	};
}

export default localize;
